(function () {

    // Bootstrap scripts
    const Bs = require("../_includes/bs.js");
    document.addEventListener("DOMContentLoaded", () => {
        let bs = new Bs();
        bs.runAll();
    });

    document.addEventListener('DOMContentLoaded', function (e) {
        document.querySelectorAll('.larativo-form-birthday').forEach(item => {
            item.addEventListener('keydown', (event) => {
                var charCode = (event.which) ? event.which : event.keyCode
                if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
                    var dateBox = event.target;
                    var chars = dateBox.value.length;
                    var text = dateBox.value;

                    if (chars == 2) {
                        dateBox.value = text + ".";
                    }
                    if (chars == 5) {
                        dateBox.value = text + ".";
                    }
                }
                else if (charCode == 37 || charCode == 39 || charCode == 46 || charCode == 8) { }
                else {
                    event.preventDefault();
                }
            })
        });
    });
})();


function isWindowScrolledToElement(element) {
  var rect = element.getBoundingClientRect();
  return rect.top <= (window.innerHeight || document.documentElement.clientHeight);
}

function toggleInViewportClass() {
  var selectors = ['.fade-in-bottom', '.fade-in-center'];
  selectors.forEach(function(selector) {
    var elements = document.querySelectorAll(selector);
    elements.forEach(function(element) {
      if (!element.classList.contains('in-viewport') && isWindowScrolledToElement(element)) {
        element.classList.add('in-viewport');
      }
    });
  });
}

window.addEventListener('scroll', toggleInViewportClass);
window.addEventListener('load', toggleInViewportClass);


window.addEventListener('scroll', function () {
  const header = document.getElementById('header');
  
  if (window.scrollY > 200) {
    header.classList.add('sticky');
  } else {
    header.classList.remove('sticky');
  }
});
window.Plugins = {};


/*	ACESSIBILIDADE
*	jBility
* https://github.com/urielcaire/jbility
*/

document.addEventListener("DOMContentLoaded", function () {
    /*===================================================================
     *  Cookie-Funktionen
     *====================================================================*/
    function createCookie(name, value, days) {
        const expires = days ? `; expires=${new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()}` : "";
        document.cookie = `${name}=${value}${expires}; path=/`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        return cookies.find(cookie => cookie.startsWith(`${name}=`))?.split('=')[1] || "";
    }

    function deleteCookie(name) {
        createCookie(name, "", -1);
    }

    /*======================================
     *  Funktionen für Kontrast
     *======================================*/
    function toggleContrast() {
        const isEnabled = getCookie("accessibility-cookie-contrast");
        if (isEnabled) {
            deleteCookie("accessibility-cookie-contrast");
            document.body.classList.remove("accessibility-on");
        } else {
            createCookie("accessibility-cookie-contrast", "enabled", 30);
            document.body.classList.add("accessibility-on");
        }
        location.reload();
    }

    // Kontrast-Button für Maus und Tastatur
    const contrastButton = document.getElementById("contrast");
    if (contrastButton) {
        contrastButton.addEventListener("click", toggleContrast);
        contrastButton.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
                toggleContrast();
                event.preventDefault();
            }
        });
    }

    /*======================================
     *  Einstellungen
     *======================================*/
    const settingsButton = document.getElementById("btn-accessibility-settings");
    const settingsMenu = document.getElementById("accessibility-settings");

    if (settingsButton && settingsMenu) {
        settingsButton.addEventListener("click", function () {
            settingsMenu.style.display = "block";
            contrastButton.focus();
        });

        settingsButton.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
                settingsMenu.style.display = "block";
                contrastButton.focus();
                event.preventDefault();
            }
        });

        // Schließt den Bereich, wenn außerhalb des Zugriffsbereichs geklickt wird
        document.addEventListener("click", function (event) {
            if (!event.target.closest("#accessibility-settings, #btn-accessibility-settings")) {
                settingsMenu.style.display = "none";
            }
        });

        // Pfeiltastensteuerung für Navigation zwischen Buttons
        const buttons = settingsMenu.querySelectorAll("button");
        buttons.forEach((button, index) => {
            button.addEventListener("keydown", function (event) {
                let nextIndex = index;
                if (event.key === "ArrowLeft") {
                    nextIndex = index > 0 ? index - 1 : buttons.length - 1;
                } else if (event.key === "ArrowRight") {
                    nextIndex = index < buttons.length - 1 ? index + 1 : 0;
                }
                buttons[nextIndex].focus();
                event.preventDefault();
            });
        });
    }

    // Ermögliche das Navigieren mit Tab außerhalb der Accessibility-Icons
    document.addEventListener("keydown", function (event) {
        if (event.key === "Tab" && settingsMenu && settingsMenu.style.display === "block") {
            settingsMenu.style.display = "none";
            const firstFooterLink = document.querySelector("footer a:first-child");
            if (firstFooterLink) firstFooterLink.focus();
        }
    });
});